var _defs, _path, _path2, _circle, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcHomeVerticket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#87d7d6;}.cls-1,.cls-3{stroke:#87d7d6;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:2px;}.cls-3{stroke-width:0.75px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.69,45.42l-3.61-6.25a2.46,2.46,0,0,1-2.43.22l3.16,5.48H9.75L26.28,16.23l7.27,12.6a2.3,2.3,0,0,1,1.94-1h.07l-8.3-14.39a1.1,1.1,0,0,0-1.51-.4,1,1,0,0,0-.4.4l-18.48,32a1.11,1.11,0,0,0,1,1.66H44.74A1.11,1.11,0,0,0,45.84,46,1.08,1.08,0,0,0,45.69,45.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.28,36.31a1.11,1.11,0,0,1-1.11-1.11V23.57a1.11,1.11,0,0,1,2.22,0V35.2A1.11,1.11,0,0,1,26.28,36.31Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.28,
    cy: 41.3,
    r: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41,39.91c-6.64,0-11.84-6.51-12-6.78a1.1,1.1,0,0,1,0-1.37c.21-.28,5.42-6.78,12-6.78S52.85,31.48,53,31.76a1.1,1.1,0,0,1,0,1.37C52.85,33.4,47.63,39.91,41,39.91Zm-9.72-7.47C32.71,34,36.58,37.69,41,37.69S49.29,34,50.7,32.44c-1.44-1.56-5.31-5.25-9.72-5.25S32.71,30.88,31.26,32.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41,36a3.58,3.58,0,1,1,3.57-3.6v0A3.59,3.59,0,0,1,41,36Zm0-5.5a1.93,1.93,0,1,0,1.91,1.94v0A1.92,1.92,0,0,0,41,30.55Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcHomeVerticket);
export default __webpack_public_path__ + "static/media/DC_Home_ver ticket.1943ca24c8171d89fae0da8a29ad7040.svg";
export { ForwardRef as ReactComponent };